const initialProps = {
  enviroment: {},
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_STATE_ENVIROMENT":
      return {
        ...state,
        enviroment: action.payload,
      };
    default:
      return state;
  }
}
